<template>
    <div class="col-12 row form-group">
        <label class="col-12 py-0 my-0 mt-2" for="input-live">Date</label>
        <div class="col-6">
            <datepicker v-model="dateStart" input-class="datepicker-here form-control digits" placeholder="Date From" format="MM/dd/yyyy"></datepicker>
        </div>
        <div class="col-6">
            <datepicker v-model="dateEnd" input-class="datepicker-here form-control digits " calendar-class="left" placeholder="Date To" format="MM/dd/yyyy"></datepicker>
        </div>
        <div class="col-6">
        <label class="my-0 mt-2" for="input-live">Application</label>
            <v-select id="application" label="name" :multiple="true" v-model="application" :options="applicationList"></v-select>
        </div>
        <div class="col-6">
            <label class="my-0 mt-2" for="input-live">Company</label>
            <v-select id="company" label="name" :multiple="true" v-model="company" :options="companyList"></v-select>
        </div>
        <div class="col-6">
        <label class="my-0 mt-2" for="input-live">Category</label>
            <v-select id="category" label="name" :multiple="true" v-model="category" :options="categoryList"></v-select>
        </div>
        <div class="col-6">
            <label class="my-0 mt-2" for="input-live">Phone</label>
            <input  class="form-control" id="phone" type="text" v-model="phone"/>
        </div>
        <div class="col-6">
        <label class="my-0 mt-2" for="input-live">Status</label>
            <v-select id="status" :multiple="false" v-model="status" :options="statusList"></v-select>
        </div>
    </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import 'vue2-timepicker/dist/VueTimepicker.css';
  import { requestService } from '../../../_services';

  export default {
    components: {
      Datepicker,
    },
    props: {
      filterTab: Number,
      module:String
    },
    data() {
      return {
        dateStart: '',
        dateEnd: '',
        application:[],
        applicationList:[],
        company:[],
        companyList:[],
        category:[],
        categoryList:[],
        statusList:["completed","fail"],
        status:"",
        phone:""
      };
    },

    watch: {
      // whenever question changes, this function will run
      filterTab(newValue, oldValue) {
        let myFilter = JSON.parse(localStorage.getItem('filter-report-case'));
        if (newValue == 1) {
          this.dateStart = myFilter.dateStart;
          this.dateEnd = myFilter.dateEnd;
          
        } else {
          this.dateStart = '';
          this.dateEnd = '';
        }
      },
    },
    mounted() {
        setTimeout(() => this.getCompany(), 1500);
        setTimeout(() => this.getApplication(), 2000);
        setTimeout(() => this.getCategory(), 2500);
    },
    methods: {
      async getCategory() {
        let url = `/api/category/all`;
        const resData = await requestService.GetFetch(this.module,url);
        const data = await resData.json();
        this.categoryList = data.data;
      },
      async getApplication() {
        let url = `/api/application/all`;
        const resData = await requestService.GetFetch(this.module,url);
        const data = await resData.json();
        this.applicationList = data.data;
      },
      async getCompany() {
        let url = `/api/company/all`;
        const resData = await requestService.GetFetch(this.module,url);
        const data = await resData.json();
        this.companyList = data.data;
      },
      getFilter() {
        var companyArr=[]
        this.company.forEach(element => {
            companyArr.push(element._id)
        });
        var applicationArr=[]
        this.application.forEach(element => {
            applicationArr.push(element._id)
        });
        var categoryArr=[]
        this.category.forEach(element => {
            categoryArr.push(element._id)
        });
        let object = {
          date_start: this.convertTimeToDate(this.dateStart),
          date_end: this.convertTimeToDate(this.dateEnd),
          company_id:companyArr.join(","),
          application_id:applicationArr.join(","),
          category_id:categoryArr.join(","),
          status:this.status,
          phone:this.phone
        };
        return object;
      },
      inputHandler(eventData) {
        console.log(eventData);
      },
      convertTimeToDate(timeStamp){
        if(timeStamp !=null && timeStamp != ""){
            var date = new Date(timeStamp.getTime());
            let year =date.getFullYear()
            let month = (date.getMonth()+1)
            if  (month <10){
                month="0"+month
            }
            let day = date.getDate()
            if  (day <10){
                day="0"+day
            }
            let dateTime =year+"-"+month+"-"+day+" 00:00:00"
            return dateTime
        }else{
          return ""
        }
      },
    },
  };
</script>

<style></style>
